import React from "react";

interface appData {
  section?: Section,
  title?: string,
  animationPath?: string,
  text: string | React.ReactNode
}
enum Section {
  CHILDREN = 'ילדים',
  MLRD_CHILDREN = 'מלר"ד ילדים',
  GENERAL = 'כללי',
}

export const showAppsData: appData[] = [
  {
    section: Section.CHILDREN,
    title: 'צהבת בילודים',
    animationPath: '/animations/hepatitis-animation.mp4',
    text: 'המלצות טיפול ליילוד, בהתאם לגילו ולבילירובין שלו.'
  },
  {
    section: Section.CHILDREN,
    title: 'אלח דם',
    animationPath: '/animations/sepsis-animation.mp4',
    text: (
    <>
      טיפול למניעת אלח דם ביילוד, ע"פ המחשבון של{' '}
      <a 
        href="https://neonatalsepsiscalculator.kaiserpermanente.org/" 
        target="_blank"
        style={{ color: 'rgb(31, 181, 163)' }}
        rel="noopener noreferrer"
      >
        קייזר
      </a>
      .
    </>
  )
  },
  {
    section: Section.CHILDREN,
    title: 'גיל מתוקן',
    animationPath: '/animations/corrected-age-animation.mp4',
    text: 'חישוב הגיל המתוקן בפגים, כולל גרפי התפתחות והמלצות לתאריכי מעקב.'
  },
  {
    section: Section.MLRD_CHILDREN,
    title: 'חדר הלם',
    animationPath: '/animations/shock-room-animation.mp4',
    text: 'ניהול הפרוצדורות בחדר הלם, מתרופות ועד החייאה.'
  },
  {
    section: Section.MLRD_CHILDREN,
    title: 'טריאז׳',
    animationPath: '/animations/triage-animation.mp4',
    text: 'סיווג המטופל במיון במספר 1-5 לפי הדחיפות, בדומה ל Canadian triage and acuity scale (ctas).'
  },
  {
    section: Section.GENERAL,
    title: 'רשימת מבחנות',
    animationPath: '/animations/lab-tests-animation.mp4',
    text: 'באילו מבחנות יש להשתמש עבור כל בדיקה.',
  }
];